export const LOAD_REPRINT = 'LOAD_REPRINT';
export const SET_REPRINT_PAGINATION = 'SET_REPRINT_PAGINATION';
export const SET_REPRINT_SORT = 'SET_REPRINT_SORT';
export const SET_REPRINT_FILTERS = 'SET_REPRINT_FILTERS';
export const RESET_REPRINT_FILTERS = 'RESET_REPRINT_FILTERS';
export const TOGGLE_REPRINT_STATUS = 'TOGGLE_REPRINT_STATUS';
export const CHECK_ORDER_ITEMS = 'CHECK_ORDER_ITEMS';
export const IGNORE_REPRINT = 'IGNORE_REPRINT';
